<template>
	<div id="app">
		<!-- 3.使用组件 -->
		<roheader  :selected_page="page_about_us"></roheader>
		<!-- <testprops title="hellsksksksksks" color='red'></testprops>
		中间内容哦耶 -->
		<!-- 内容 -->
		<div class="ro-home-content">
			<div class="ro-home-content-box">
				<div style="width:1100px;background-color: white;padding:50px;margin: auto;box-shadow:0px 0px 20px #8a8a8a;">
					<!-- <img src="../static/picture/sf_test.png" style="width: 75%;"/> -->
					<div style="overflow: hidden;">
						<div class="section-title" style="padding:20px 0;background-color: white;margin-bottom: 0;">
							<h3>机构简介</h3>
							<span class="h3 text-theme sec-subtitle" style="margin-top: -20px;">Organization Profile</span>
						</div>
						<div style="text-align: left;padding:20px;">
							<div v-html="about_us"/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>
</template>
<script>
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";

	import testprops from "./components/test_props.vue";
	import {
		fetchPost
	} from "@/utils/request"
	export default {
		name: "App",
		data() {
			return {
				page_about_us:'关于我们',
				about_us:'',
			}
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			testprops,
		},
		mounted() {
			this.get_home_setting()
		},methods: {
			get_home_setting() {
				var self = this
				fetchPost('/ro/tec_search/settings/website/v1').then(response => {
					self.about_us = response.data.list.about_us
					
				})
			}}
	};
</script>
<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.ro-home-content {
		width: 100%;
		background: #F0F0F0;
		overflow: auto;
		padding: 20px 0;
		background-image: url(../assets/img/bg/bg-7.jpg);
		background-repeat: no-repeat;
		background-position: 50%;
		background-size: cover;
	}

	.ro-home-content-box {
		width: 1140px;
		margin: auto;
		padding: 40px 0;
	}
</style>
